import React, { useEffect, useRef } from 'react';
import { CaretLeft, type Icon } from '@phosphor-icons/react';
import { ueberlagerungOffen } from './ueberlagerung';

/**
 * Bereich der Einheit (README §5.5): ersetzt das Raster und gleitet mit sideIn ein.
 * Kopf: „‹ Alle Widgets“ + Icon-Kachel + Titel.
 */
export interface SlidePanelProps {
  titel: string;
  icon: Icon;
  onZurueck: () => void;
  /** Optional rechts im Kopf, z. B. eine Aktion. */
  aktion?: React.ReactNode;
  children: React.ReactNode;
}

export function SlidePanel({ titel, icon: IconKomp, onZurueck, aktion, children }: SlidePanelProps) {
  const zurueck = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    zurueck.current?.focus({ preventScroll: true });
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape' && !ueberlagerungOffen()) onZurueck(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onZurueck]);

  return (
    <section className="immo-side-in flex flex-col" style={{ gap: 14 }} aria-label={titel}>
      <div className="flex items-center flex-wrap" style={{ gap: 12 }}>
        <button
          ref={zurueck}
          type="button"
          onClick={onZurueck}
          className="immo-hover-flaeche flex items-center cursor-pointer"
          style={{ height: 36, padding: '0 14px 0 10px', borderRadius: 18, border: 'none', gap: 6, background: 'var(--fill2)', fontSize: 13, fontWeight: 700, color: 'var(--ink)' }}
        >
          <CaretLeft weight="bold" size={13} />
          Alle Widgets
        </button>
        <h2 className="flex items-center m-0" style={{ gap: 10, fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em' }}>
          <span className="flex items-center justify-center" style={{ width: 38, height: 38, borderRadius: 12, background: 'var(--acc-soft)' }}>
            <IconKomp weight="fill" size={19} color="var(--acc)" />
          </span>
          {titel}
        </h2>
        {aktion && <div className="ml-auto">{aktion}</div>}
      </div>
      {children}
    </section>
  );
}
